import "./style.css";

interface StaticAlertProps {
  heading?: string;
  desc?: string;
  type?: string;
}

type AlertType = {
  default: string;
  warning: string;
  [key: string]: string; // Add index signature
};

const alertType: AlertType = {
  default: "bg-blue100",
  warning: "bg-light-yellow",
  error: "bg-accent-red mt-4 mx-4",
};

const StaticAlert = (props: StaticAlertProps) => {
  const { heading, desc, type } = props;
  const classes = `static-alert ${type ? alertType[type] : alertType.default}`;
  return (
    <div className={classes} data-testid="static-alert">
      {heading ? <h1 dangerouslySetInnerHTML={{ __html: heading }} /> : null}
      {desc && (
        <p
          className={`text-sm ${heading ? "mt-4" : ""}`}
          dangerouslySetInnerHTML={{ __html: desc }}
        />
      )}
    </div>
  );
};

export default StaticAlert;
